
(function($, CartJS, tippy) {
  /**
   * Checks if a given CartJS `Item` has a paid (non-tester) version in an
   * array of `Item`s by comparing SKUs.
   *
   * @param Object<{id, sku...}> tester    The tester item.
   * @param Array<Item>          cartItems The cart items.
   *
   * @return boolean
   */
  function hasPaidProductInCart(product, cartItems) {

    var numItems = 0;
    var numTesters = 0;
    var numSamples = 0;
    var isInCart = false;

    var regular_sku = product.sku.slice(0,-1);

    $.each(cartItems, function(index, item) {
      if( regular_sku === item.sku ){
        numItems += item.quantity;
      } else if(item.sku === (regular_sku + 'T')) {
        numTesters += item.quantity;
      //} else if(item.sku === (regular_sku + 'S')){
        //numSamples += item.quantity;
      }
    });

    //get the possible amount of testers
    var availableTesters = Math.floor(numItems/4);

    //checking if any testers are still available
    if ((numTesters + numSamples) < availableTesters){
      isInCart = true;
    }

    return isInCart;
  }

  /**
   * Removes tippy from an element, smoothly.
   *
   * @param Node element
   *
   * @return void
   */
  function destroyTooltip(selector) {
      if ('undefined' !== typeof(selector._tippy)) {
        selector._tippy.destroy();
      }
  }

  var testerToolTip = 'One tester allowed per 4 regular products!';

  $(document).ready(function() {
    $.each(window.Koru.pageProductVariants, function(i, variant) {
      tippy(
        '#row-'+variant.id,
        {
          dynamicTitle: true,
          placement: 'bottom',
          hideOnClick: false
        }
      );
    });
  });

  var handleCartButtons = function(event, cart) {
    var paidCartProducts     = [];
    var pageVariants         = window.Koru.pageVariants;

    $.each(cart.items, function(index, item) {
      if ('T' !== item.sku.slice(-1)){ //&& 'S' !== item.sku.slice(-1)) {
        paidCartProducts.push(item);
      }
    });

    if (0 < pageVariants.length) {

      $.each(pageVariants, function(index, variant) {
        try {
          var productId = variant.featured_image.product_id;
        } catch (e) {
          return true; // 'continue'; we can't do anything with this product.
        }
        var radioSelector = $('#radio_' + variant.id);
        var addToCart     = $('input[type=submit].product-list-item-submit-'+productId);
        var variantForm   = document.querySelector('.product-list-item-details-form-'+productId);

        // If it's not a tester, make sure addToCart will work.
        if (('T' !== variant.sku.slice(-1))){ //&& ('S' !== variant.sku.slice(-1))) {
            radioSelector.click(function() {
            addToCart.removeProp('disabled');
            destroyTooltip(variantForm);
          });
          return true; // 'continue'; we don't want the event handler below
        }

        $(document).on('cart.requestComplete', function() {
          testerButton = radioSelector[0].checked;
          if ((false === hasPaidProductInCart(variant, cart.items)) && (testerButton == true)){
            addToCart.attr('disabled', 'disabled');
          }
        });

        radioSelector.click(function() {
          if (true === hasPaidProductInCart(variant, cart.items)) {
            addToCart.removeProp('disabled');
            destroyTooltip(variantForm);
          } else {
            addToCart.attr('disabled', 'disabled');

            // Set up tooltip
            $(variantForm).attr('title', testerToolTip);
            tippy(variantForm);

            // Fire it up instantly
            setTimeout(function() {
              variantForm._tippy.show();
            }, 500);
          }
        });
      });
    }
  };

  var handleProductTable = function(event, cart) {
    var pageProductVariants  = window.Koru.pageProductVariants;
    var paidCartProducts     = [];

    if (0 < pageProductVariants.length) {
      $.each(pageProductVariants, function(index, variant) {
        var $qty    = $('[data-table-submit-qty='+variant.id+']');
        var $submit = $('[data-table-submit-btn-variant='+variant.id+']');
        var row     = document.querySelector('#row-'+variant.id);

        // If it's a regular, paid product, skip it!
        if ('T' !== variant.sku.slice(-1)){ //&& ('S' !== variant.sku.slice(-1))) {
          destroyTooltip(row);
          return true; // 'continue';
        }

        if (false === hasPaidProductInCart(variant, cart.items)) {
          $qty.attr('disabled', 'disabled')
          $submit.attr('disabled', 'disabled');

          // Set up tooltip
          $('#row-'+variant.id).attr('title', testerToolTip);
        } else {
          $qty.removeProp('disabled').removeProp('title');
          $submit.removeProp('disabled').removeProp('title');
          destroyTooltip(row);
        }
      });
    }
  };

  $(document).on('cart.ready cart.requestComplete', handleCartButtons);
  $(document).on('cart.ready cart.requestComplete', handleProductTable);

})(jQuery, CartJS, tippy);
